import { ARBITRUM, ARBITRUM_TESTNET, AVALANCHE, MAINNET, ETHEREUM, SHIBARIUM, GOERLI, PUPPY_NET, FANTOM, MUMBAI,  } from "./chains";

// export const TAIL_STATS_API_URL = "https://stats.mummy.finance/api";
export const TAIL_STATS_API_URL = "https://stats.gmx.io/api";

const BACKEND_URLS = {
  // default: "https://gmx-server-mainnet.uw.r.appspot.com",
  default: "https://api.mummy.finance/api",

  [MAINNET]: "https://gambit-server-staging.uc.r.appspot.com",
  [ARBITRUM_TESTNET]: "https://gambit-server-devnet.uc.r.appspot.com",
  [ARBITRUM]: "https://gmx-server-mainnet.uw.r.appspot.com",
  [AVALANCHE]: "https://gmx-avax-server.uc.r.appspot.com",

  [ETHEREUM]: "https://api.mummy.finance/api",
  [SHIBARIUM]: "https://api.mummy.finance/api",

  [GOERLI]: "https://api.mummy.finance/api",
  [PUPPY_NET]: "https://api.mummy.finance/api",
  
  [MUMBAI]: "https://api.mummy.finance/api",
  [FANTOM]: "https://api.mummy.finance/api",
};

export function getServerBaseUrl(chainId: number) {
  if (!chainId) {
    throw new Error("chainId is not provided");
  }

  if (document.location.hostname.includes("deploy-preview")) {
    const fromLocalStorage = localStorage.getItem("SERVER_BASE_URL");
    if (fromLocalStorage) {
      return fromLocalStorage;
    }
  }

  return BACKEND_URLS[chainId] || BACKEND_URLS.default;
}

export function getServerUrl(chainId: number, path: string) {
  return `${getServerBaseUrl(chainId)}${path}`;
}
